import React from 'react'
import { Button, SummaryList, Price } from '@superhi/design'

import { Wrapper } from './styles'

import { API } from 'src/api'
import { buildPath } from 'src/routing'

type Props = {
  subtotal: number
  shipping?: number
  discounts: string[]
  totalDiscount: number
  total: number
  currencyCode: API.CurrencyCode
}

const Summary: React.FC<React.PropsWithChildren<Props>> = ({
  subtotal,
  shipping,
  totalDiscount,
  discounts = [],
  total,
  currencyCode,
}) => (
  <Wrapper>
    <SummaryList
      items={
        [
          {
            title: 'Subtotal',
            price: Price.format(subtotal, currencyCode),
          },
          typeof shipping === 'number' && {
            title: 'Shipping',
            price: Price.format(shipping, currencyCode),
          },
          totalDiscount > 0 && {
            title: 'Discount',
            subtitle: discounts.join(', '),
            price: Price.format(-totalDiscount, currencyCode),
          },
          {
            title: 'Total',
            price: Price.format(total, currencyCode),
            isBold: true,
          },
        ].filter(Boolean) as React.ComponentProps<typeof SummaryList>['items']
      }
    />

    <Button href={buildPath('checkout-info')} fullWidth>
      Checkout
    </Button>
  </Wrapper>
)

export default Summary
